import type { IAuditLogEntryView } from "@dealer-center/ddc-pages-account-franchise-audit-log-fetch";
import type { TypeSafeTableColumns } from "@dealer-center/core-components";
import { normalizeApiDate } from "@dealer-center/ddc-pages-account-franchise-audit-log-interface";

export const formatTimeDetail = (dateStr: string): string => {
  if (!dateStr) return "";
  const date = new Date(normalizeApiDate(dateStr));
  if (isNaN(date.getTime())) return "";
  return date.toLocaleString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true
  });
};

export const getFilteredData = (
  data: IAuditLogEntryView[],
  filterBy: string | undefined,
  columns: TypeSafeTableColumns<IAuditLogEntryView>
): IAuditLogEntryView[] => {
  if (!filterBy) {
    return data;
  }
  return data.filter(item =>
    columns.some(c => {
      const key = c.dataIndex as keyof IAuditLogEntryView | undefined;
      const value = key ? item[key] : undefined;
      return value != null
        ? String(value).toLowerCase().includes(filterBy.toLowerCase())
        : false;
    })
  );
};
